export default {"src":"/_next/static/media/commercial.f830f8b8.svg","height":50,"width":50};